module.exports = __webpack_public_path__ + "img/modal1@2x.c77b1d00.png";